import appConfigCoverGoProd from "./appConfigCoverGoProd.js"
import { COVERGO_SAAS_DEV, COVERGO_ASIA_PROD } from "../consts.js"

export const insuredNomads = {
	"insured-nomads-uat-studio.quote.hk": { appConfig: appConfigCoverGoProd, envConfig: COVERGO_SAAS_DEV },
	"insured-nomads-studio.quote.hk": {
		appConfig: { ...appConfigCoverGoProd, tenantId: "insuredNomads" },
		envConfig: COVERGO_ASIA_PROD
	}
}
